import React from 'react';

export default () => (
    <path
        d="M90,124 L10,124 C4.5,124 0,119.5 0,114 L0,10 C0,4.5 4.5,0 10,0 L50.7,0 C53.4,0 55.9,1 57.8,2.9 L97.1,42.2 C99,44.1 100,46.6 100,49.3 L100,114 C100,119.5 95.5,124 90,124 Z M10,4 C6.7,4 4,6.7 4,10 L4,114 C4,117.3 6.7,120 10,120 L90,120 C93.3,120 96,117.3 96,114 L96,49.3 C96,47.7 95.4,46.2 94.2,45.1 L54.9,5.8 C53.8,4.6 52.3,4 50.7,4 L10,4 Z"
        id="Shape"
    />
);
